import {
  Injectable
} from '@angular/core';
import {
  Observable
, 
  BehaviorSubject
, 
  Subscription
} from 'rxjs';

import {
  HttpParams
} from '@angular/common/http';
import {
  GridDataResult
} from '@progress/kendo-angular-grid';
import {
  ApiService
} from '../../../../services/api/api.service';

@Injectable()
export class LocationsService extends BehaviorSubject<GridDataResult> {
  public subscription: Subscription;

  constructor(private api: ApiService) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));
  }

  public getLocations(page: number, limit: number, cb: any, accountId: string, search?: string) {
    const params = new HttpParams()
      .set('page', page.toLocaleString())
      .set('limit', limit.toString())
      .set('search', search)
      .set('account', accountId);

    this.subscription = this.api.get<GridDataResult>(`/account/${accountId}/location`, params)
      .subscribe(result => {
        super.next(result);
      });
  }
}
